import { INICIALITZAR, OMPLIR_USUARI_AUTENTICAT } from "../actions/actionTypes";

const ESTAT_INICIAL = {};

const usuarisReducer = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case OMPLIR_USUARI_AUTENTICAT: {
      return action.payload;
    }

    case `${OMPLIR_USUARI_AUTENTICAT}_EN_CURS`:
      return {
        ...state
      };

    case `${OMPLIR_USUARI_AUTENTICAT}_SUCCESS`:
      return action.payload;

    case `${OMPLIR_USUARI_AUTENTICAT}_ERROR`:
      return {
        ...state,
        error: action.error
      };

    default:
      return state;
  }
};

export default usuarisReducer;

export const getUsuari = state => state || ESTAT_INICIAL;
export const getIdUsuari = state => (state ? state.id : null);
export const getIdObservador = state => (state ? state.idObservador : null);
